const CHANGE_ADD_LIST_STATUS = "CHANGE_ADD_LIST_STATUS"
const ADD_NEW_LIST = 'ADD_NEW_LIST'
const ADD_NEW_ITEM = 'ADD_NEW_ITEM'
const DELETE_LIST = 'DELETE_LIST'
const DELETE_ITEM = 'DELETE_ITEM'
const EDIT_LIST_TITLE = 'EDIT_LIST_TITLE'
const ADD_DESCRIPTION = 'ADD_DESCRIPTION'
const EDIT_ITEM_TITLE = 'EDIT_ITEM_TITLE'
const DROP_ITEM = 'DROP_ITEM'

export { CHANGE_ADD_LIST_STATUS, ADD_NEW_LIST, ADD_NEW_ITEM, DELETE_LIST, DELETE_ITEM, EDIT_LIST_TITLE, ADD_DESCRIPTION, EDIT_ITEM_TITLE, DROP_ITEM }